import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { TemplateActivatePayload } from 'Interfaces/Document';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: TemplateActivatePayload) =>
    $actions.document.activateTemplate(dispatch, payload),
  );
};
